import { render } from "./GitHubLogo.vue?vue&type=template&id=aa019310"
import script from "./GitHubLogo.vue?vue&type=script&lang=js"
export * from "./GitHubLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__